/* eslint-disable no-undef */
export const root = document.querySelector('#root');

export const menuBtnPainterQuiz = () => document.querySelector('.menu-btn-painter-quiz');
export const menuBtnPictureQuiz = () => document.querySelector('.menu-btn-picture-quiz');
export const menuBtnSettingQuiz = () => document.querySelector('.menu-btn-setting-quiz');
export const categoriesBtnHome = () => document.querySelector('.categories-page-home-btn');
export const categoriesBtnScore = () => document.querySelector('.categories-page-score-btn');
export const volumeSettingRange = () => document.querySelector('#volume-setting');
export const volumeIconBtn = () => document.querySelector('.volume-icon');
export const volumeBigBtn = () => document.querySelector('.volume-img');
export const audio = () => document.querySelector('audio');
export const timerContainer = () => document.querySelector('.timer');
export const timerSettingCheckbox = () => document.querySelector('#timer-setting');
export const timeRange = () => document.querySelector('#time-range');
export const timeRangeText = () => document.querySelector('.time-range-text');
export const timeRangeContainer = () => document.querySelector('.time-range-container');
export const settingBtnSave = () => document.querySelector('.setting-btn-save');
export const settingBtnDefault = () => document.querySelector('.setting-btn-default');
export const btnBackCategories = () => document.querySelector('.btn-back-categories');
export const categoriesItems = () => document.querySelectorAll('.categories-item');
export const questionItems = () => document.querySelectorAll('.question-item');
export const scoreItems = () => document.querySelectorAll('.score-item');
export const sliderItems = () => document.querySelectorAll('.slider-item');
export const nextQuestionBtn = () => document.querySelector('.next-question-btn');
export const scoreItemsBtn = () => document.querySelectorAll('.item-btn-score');
export const restartModalBtn = () => document.querySelector('.restart-modal-btn');
export const backModalBtn = () => document.querySelector('.back-modal-btn');
export const currentCategories = () => document.querySelector('.current-categories');
export const modalWrapper = () => document.querySelector('.modal-wrapper');
export const modalWindowContainer = () => document.querySelector('.modal-window-container');
export const mainQuestionPage = () => document.querySelector('.main-question-page');
export const mainCategoriesPage = () => document.querySelector('.main-categories-page');
export const iconAnswer = () => document.querySelector('.icon-answer');
export const restartModal = () => document.querySelector('.restart-modal');
export const modalResultStars = () => document.querySelectorAll('.modal-result-img');
export const currentScoreContainer = () => document.querySelector('.current-score-container');
